AgrimarketControllers.controller('outstandingsController', [
	'$rootScope', '$location',
	function ($rootScope, $location) {

		if (!$rootScope.ModuleMyAccount.Active)
			$location.path('/');
		
	}
]);